import { useEffect } from 'react';

import { setColonyColorOverrides } from '../../canvas/bee-palette';

export interface PresentationPalette {
  red: string;
  blue: string;
}

/** Installs one presentation palette across CSS chrome and the cached Pixi colour resolver. */
export function usePresentationPalette(palette: PresentationPalette | undefined): void {
  useEffect(() => {
    if (palette === undefined) return undefined;
    const rootStyle = document.documentElement.style;
    const previous = [
      rootStyle.getPropertyValue('--colony-0'),
      rootStyle.getPropertyValue('--colony-1'),
    ];
    rootStyle.setProperty('--colony-0', palette.red);
    rootStyle.setProperty('--colony-1', palette.blue);
    const restoreCanvasPalette = setColonyColorOverrides([
      Number.parseInt(palette.red.slice(1), 16),
      Number.parseInt(palette.blue.slice(1), 16),
    ]);
    return () => {
      restoreCanvasPalette();
      if (previous[0] === '') rootStyle.removeProperty('--colony-0');
      else rootStyle.setProperty('--colony-0', previous[0]);
      if (previous[1] === '') rootStyle.removeProperty('--colony-1');
      else rootStyle.setProperty('--colony-1', previous[1]);
    };
  }, [palette?.blue, palette?.red]);
}
